var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWindowsMinimize = function SvgWindowsMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1849 -3094.4 10 0.8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "windows_minimize_svg__a",
    d: "M-1849-3093.6v-.8h10v.8Z"
  })));
};
export default SvgWindowsMinimize;